import { render, staticRenderFns } from "./menus-group.vue?vue&type=template&id=2ca532a4&scoped=true"
import script from "./menus-group.vue?vue&type=script&lang=js"
export * from "./menus-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca532a4",
  null
  
)

export default component.exports